module.exports = __webpack_public_path__ + "img/11_non_open_L3.72ac5872.svg";